import Axios from '@/Axios'

class MitemService {
    async getMitems(data = {}) {
        return await Axios.get('wms.wms.api.mitem.get_mitems', {
            params: data,
        })
    }
    async createMitem(data) {
        return await Axios.post('wms.wms.api.mitem.create_mitem', data)
    }
    async deleteMitem(mitem) {
        const transformed_mitem = mitem.map((item) => ({ name: item }))
        return await Axios.delete('wms.wms.api.mitem.delete_mitem', { data: {mitem:transformed_mitem} })
    }
    async getMitem(mItemId) {
        return await Axios.get('wms.wms.api.mitem.get_mitem_by_id', { params: { mitem: mItemId } })
    }
    async updateMitem(data) {
        
        return await Axios.put(`wms.wms.api.mitem.update_mitem`, data)
    }
}
export default  new MitemService()
